var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"dashboard"},[_c('getting-started'),(_vm.authOrigin !== 'app')?_c('dashboard-definitions',{on:{"period":_vm.handlePeriod}}):_vm._e(),_c('br'),_c('dashboard-charts',{attrs:{"period":_vm.period}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }